import type { ReactNode } from 'react';
import { STUBS } from './demo-data.js';

/**
 * 六个**结构占位**页签（原型 v0.22 第 1093–1101 行 `stubHTML`）。
 *
 * ## 这六页在原型里本来就是占位，不是我搬漏了
 *
 * 原型自己写着「结构占位 · 本页信息架构已定，数据接入后填充」——
 * 任务跟踪 / 审批中心 / 日常审计 / 承诺与结算 / 数据与接入 / 建设进度，
 * 六页在原型里走的是同一个 `stubHTML`，各自只有一段说明与四个模块名。
 *
 * **搬入的是那份信息架构本身**（哪一页管什么、分几块），这有价值：
 * 它是已裁定的页面职责，写在这里比写在一份 HTML 里更不容易丢。
 *
 * ## 整页标**无源**（C-160 口径一）
 *
 * 这六页没有一格数，四个模块名是**页面职责的文字说明**，不是演示数据。
 * 而它们各自要的源（检查点、审批队列、审计记录、承诺清单、胶囊域、里程碑基线）
 * **一个都还没建**，故整页是无源——不是零态（零态是「表在、没数据」）。
 *
 * ## 不放假控件
 *
 * 原型那句「本页遵守产品边界：看结果、做审批、触发任务；无操作型控件（B-1 至 B-8）」
 * 照搬。**不给按钮**——一个点了没反应的按钮比没有更坏，
 * 它让人以为功能在那儿只是坏了（与 `renameNodeTypeSchema` 删字段同一条理由）。
 */
export type StubKey = keyof typeof STUBS;

export const STUB_KEYS: readonly StubKey[] = [
  'track',
  'approve',
  'audit',
  'commit',
  'data',
  'build',
];

export function StubView({ which }: { which: StubKey }): ReactNode {
  const stub = STUBS[which];
  return (
    /* 包进 `.pv22`：`card` / `stub` / `t2` / `note` 都在原型作用域里（同 AssetLedger）。 */
    <div className="pv22">
      <div className="card">
        <h3>
          {stub.t} <span className="sub">结构占位 · 本页信息架构已定，数据接入后填充</span>{' '}
        </h3>
        <div className="note" style={{ marginBottom: 10 }}>
          {stub.d}
        </div>
        {stub.blocks.map((block, i) => (
          <div className="stub" key={block}>
            <div className="t2">模块 {i + 1}</div>
            <div className="note">{block}</div>
          </div>
        ))}
        <div className="note">
          本页遵守产品边界：看结果、做审批、触发任务；无操作型控件。
        </div>
      </div>
    </div>
  );
}
